import React from "react"
import { Button } from "../../components/Button/Button"
import { useMutation } from "react-query";
import { AuthService } from "../../services/auth.service";
import { FormikProvider, useFormik } from "formik";
import { Asserts, number, object, string } from "yup";
import { TextInput } from "../../components/FormInputs/TextInput";
import { AuthActions } from "../../zustand/auth.store";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";


export const RequestPasswordReset = () => {
  const navigate = useNavigate()
  const validationSchema = object({
    username: string().required().label("Username")
  });
  const form = useFormik<Asserts<typeof validationSchema>>({
    initialValues: {
      username: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const payload = {
        "phoneNumber": values.username
    }
    submitForget.mutate(payload)
    },
  });

  const submitForget = useMutation(
    async (values: { phoneNumber: string }) => {
     localStorage.setItem("resetId", values.phoneNumber)
      return await AuthService.resetPassword(values)
    },
    {
      onSuccess: (response) => {
        if (response.data.responseCode === "00") {
          toast.success(response.data.responseMessage);
          requestAnimationFrame(() => {
            navigate("/enter-otp");
          });
        } else {
          toast.error(response.data.responseMessage);
          
        }
        
      },
      onError: (err: any) => { 
        toast.error(err.response.data.responseMessage);
        
      },
    }
  )
  return (
    <div>
      <div className="card bg-white rounded-md p-9">
        <div className="flex justify-around">
          <img
            src={"/images/pc-logo.svg"}
            className=""
            alt="Paycenter_logo"
          />
        </div>
        <div className="mt-6">
          <h5 className="text-center font-bold">Reset Password</h5>
        </div>
        <div>
          <FormikProvider value={form}>
          <form onSubmit={form.handleSubmit}>
          
            <div className="mt-4 w-80">
              <TextInput
                type="text"
                label="Enter ID"
                {...form.getFieldProps("username")}
                placeholder="Enter your ID"
                context
              />
            </div>
            <div className="mt-4">
              <Button label="Reset Password" isLoading={submitForget.isLoading} className="justify-center" fullWidth disabled={submitForget.isLoading} />
            </div>
          </form>
          </FormikProvider>
        
        </div>
      </div>

    </div>
  )
}